import Spinner from "components/Spinner";
// import CampusEditor from "components/campus/CampusEditor";
import React, { Suspense, lazy } from "react";
const CampusEditor = lazy(() => import("components/campus/CampusEditor"));

const Campus = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <CampusEditor />
    </Suspense>
  );
};

export default Campus;
